module.exports = __webpack_public_path__ + "media/images/enabled_dispatcher-b11caa07aa9312a8670df9f13c83e874.svg";